import { Avatar, Button, Dialog, DialogTitle, Divider, Grid, Typography } from "@material-ui/core";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import TitleDialog from "~/components/modalBookingScreen/TitleDialog";
import Utils from "~/helpers/Utils";
import bookingTransactionService, { getOneBookingTransaction } from "~/services/bookingTransactionService";
import businessService from "~/services/businessService";
import payPaymentService, { stripeKey } from "~/services/payPaymentService";
import { DialogBuilder } from "~/utils/DialogProvider";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { getBookingOrigin } from "~/utils/bookingOrigin";
import { TIPO_ATENDIMENTO } from "~/utils/appointmentType";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { withRouter } from "react-router"

import DialogError from ".";
import SpinnerLoading from "../spinnerLoading/SpinnerLoading";
import ButtonDefault from "~/components/common/ButtonDefault";
import useStyles from "./style";

const DialogPayConfirmPackage = (props) => {
	const { i18n, t } = useTranslation();
	const dialog = useContext(DialogBuilder);
	const [clientSecret, setClientSecret] = useState(null);
	const [stripePromise, setStripePromise] = useState(null);
	const [errorMessage, setErrorMessage] = useState("Erro inesperado, tente novamente.");
	const [errorOpen, setErrorOpen] = useState(false);
	const [bookingTransactionId, setBookingTransactionId] = useState(null);

	const appearance = {
		theme: "stripe",
	};

	const options = {
		clientSecret: clientSecret,
		appearance,
	};

	const showError = (message) => {
		setErrorMessage(message);
		setErrorOpen(true);
	};

	const {
		postPayment,
		onClose,
		cardData,
		pix,
		checkoutInformation,
		currency,
		coupon,
		payload,
		postBooking,
		setPixCode,
		onPixUnblock,
		showUpdateInfo,
		hasActivatedPackage,
		singleServices,
		selectedPackages,
		checkoutInformationServices
	} = props;
	
	const isPostPayment = !_.isNil(postPayment) && !_.isObject(postPayment) && _.has(postPayment, "booking_external_id");

	const classes = useStyles();
	const { user } = useSelector((store) => store.auth);
	const { business } = useSelector((store) => store.business);
	const { me } = useSelector((state) => state.me);
	const [loading, setLoading] = useState(false);

	const getPaymentFlowType = () => {
		const hasPackages = selectedPackages && selectedPackages.length > 0;
		const hasSingleServices = singleServices && singleServices.length > 0;
		
		if (hasPackages && hasSingleServices) {
			return 'packagesAndServices';
		} else if (hasPackages && !hasSingleServices) {
			return 'onlyPackages';
		} else if (!hasPackages && hasSingleServices) {
			return 'services';
		}
		return 'services'; // fallback
	};

	const calculatePaymentValues = () => {
		const flowType = getPaymentFlowType();
		
		switch (flowType) {
			case 'services':
				// Apenas serviços avulsos - usar checkoutInformation normal
				return {
					flowType: 'services',
					totalValue: checkoutInformation?.total_value_for_services || 0,
					amountToPay: checkoutInformation?.amount || 0,
					anticipationPayment: checkoutInformation?.anticipation_payment || 0,
					remainingValue: (checkoutInformation?.total_value_for_services || 0) - (checkoutInformation?.anticipation_payment || 0)
				};
				
			case 'onlyPackages':
				return {
					flowType: 'onlyPackages',
					totalValue: checkoutInformation?.total_value_for_services || 0,
					amountToPay: checkoutInformation?.amount || 0,
					anticipationPayment: 0, 
					remainingValue: 0
				};
				
			case 'packagesAndServices':
				const packageValue = checkoutInformation?.total_value_for_services || 0;
				const servicesAnticipation = checkoutInformationServices?.anticipation_payment || 0;
				const totalServicesValue = singleServices.reduce((total, service) => {
					return total + (service.professional?.price || 0);
				}, 0);
	
				const result = {
					flowType: 'packagesAndServices',
					totalValue: packageValue + totalServicesValue,
					amountToPay: packageValue + servicesAnticipation,
					anticipationPayment: servicesAnticipation,
					remainingValue: totalServicesValue - servicesAnticipation
				};
				
				return result;
				
			default:
				return {
					flowType: 'services',
					totalValue: 0,
					amountToPay: 0,
					anticipationPayment: 0,
					remainingValue: 0
				};
		}
	};

	const publishBookingtranscation = async (bookTransactionId) => {
		try {
			const bookingTransactionPublishRequest = await bookingTransactionService.publishBooktranscation(
				bookTransactionId
			);
			return bookingTransactionPublishRequest.data;
		} catch (err) {}
	};

	const submitPayment = async () => {
		setLoading(true);
			postBooking()
				.then(async (book) => {
					setBookingTransactionId(book.data.bookings[0].bookingTransactionId);
					pay(book.data.bookings[0].bookingTransactionId, business.id);
				})
				.catch((err) => {
					const message = err?.response?.data?.message;
					showError(message || "Verifique sua conexão e tente novamente");
					setLoading(false);
				});
	}; 

	const typePaymentPackage = async () => {
		try {
			switch (hasActivatedPackage) {
				case true:
					setLoading(true);
					return await postBooking();
				case false:
					return await submitPayment();
				default:
					return await submitPayment();
			}
		} catch (error) {
			const message = error?.response?.data?.message;
			showError(message || "Verifique sua conexão e tente novamente");
			setLoading(false);
		}
	}

	const paymentInfo = (flowCheckout) => {
		switch (flowCheckout) {
			default:
				return null;
		}
	}

	const pay = (bookingTransactionId, recipient_id) => {
		const meData = JSON.parse(localStorage.getItem("@prit-web/meData"));
		businessService
			.getBusiness(business.id)
			.then(async (res) => {
				const businessUpdated = res.data;
				const postalCode = businessUpdated?.address?.postalCode?.trim();
				if (
					businessUpdated.phone.startsWith("+55") &&
					postalCode &&
					!/^\d{8}$/.test(postalCode.replace("-", ""))
				) {
					showError(t("adress problems"));
					setLoading(false);
					return;
				}
				const address = businessUpdated.address || business.adress;
				const paypamentPay = {
					booking_external_id: bookingTransactionId,
					recipient_id: recipient_id,
					card: cardData && {
						card_holder_name: cardData.name,
						card_expiration_date: cardData.expiry,
						card_number: cardData.number,
						card_cvv: cardData.cvc,
					},
					client: {
						id: user?.id || me?.id || localStorage.getItem("@prit-web/userId") || meData?.id,
						name:
							me?.name ||
							user?.displayName ||
							cardData?.name ||
							Utils.safeLocalGet("@prit-web/userName") ||
							meData?.name ||
							"Usuário Prit",
						email:
							user?.email ||
							cardData?.email ||
							me?.email ||
							meData?.email ||
							"contato@prit.app",
						country: "br",
						documents: [cardData ? cardData.cpf : pix],
						phone_numbers: me?.phone ? [me.phone] : meData?.phone ? [meData?.phone] : [meData?.phoneUnverified],
						address: {
							street: address?.street || "Av. Prof. João Fiúsa",
							complementary: address?.unit || "",
							street_number: address?.number || "1901",
							neighborhood: address?.neighborhood || "Jardim Botânico",
							city: address?.city || "Ribeirão Preto",
							state: address?.state || "SP",
							zipcode: address?.postalCode || "14024250",
							country: "br",
						},
					},
					amount: checkoutInformation?.amount / 100,
					discount: checkoutInformation?.total_discounts / 100,
					payment_type: pix ? 5 : null,
				};
				if (coupon) {
					paypamentPay.coupon_id = coupon.coupon_id;
				}
				if (currency !== "BRL") {
					const res = await payPaymentService.postPayIntent(paypamentPay);
					setClientSecret(res.data.payment_intent_client_secret);
					setStripePromise(loadStripe(stripeKey, { stripeAccount: res.data.connect_account_id }));
				} else {
					publishBookingtranscation(bookingTransactionId);
					payPaymentService
						.postPaymentPay(paypamentPay)
						.then((paymentPayRequest) => {
							if (pix) {
								let waitingPixPayment = setInterval(() => {
									getOneBookingTransaction(bookingTransactionId).then((res) => {
										let status = res.data.paymentStatus;
										if (status !== "pending") {
											clearInterval(waitingPixPayment);
											if (status === "partial" || status === "completed") {
												if (onPixUnblock) onPixUnblock();
												props.history.push(
													`/confirmation-package/${business.id}/bookingTransactionId/${bookingTransactionId}`,
													{ infoPackage: payload }
												);
											}
										}
									});
								}, 5000);
								setPixCode(paymentPayRequest.data.pix_qr_code);
								setLoading(false);
							} else {
								const currentUser = me || user || {};
								const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
								mixpanelTrackEvent('Novo_Agendamento',
									{
										"Forma_De_Agendamento": 'Web_Consumidor',
										"Meio_De_Pagamento": 'Nenhum',
										"Tipo_De_Login": typeLogin || null,
										"Origem_De_Agendamento": getBookingOrigin(),
										"tipo_atendimento": TIPO_ATENDIMENTO.SESSAO_DE_PACOTE,
									},
								currentUser, business, true);
								let isOwnerUser = !_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;
								mixpanelTrackEvent('Agendamento_Confirmado', currentUser, isOwnerUser ? business : {});
								setLoading(false);
								props.history.push(
									`/confirmation-package/${business.id}/bookingTransactionId/${bookingTransactionId}`,
									{ infoPackage: payload }
								);
							}
						})
						.catch((err) => {
							if (!isPostPayment) {
								bookingTransactionService.putBookingTransaction(bookingTransactionId);
							}
							let message = err?.response?.data?.message || err?.message;
							if (message && message.includes && message.includes("email")) {
								showError("O email informado é inválido, por favor, verifique e tente novamente");
							} else {
								showError(message || "Verifique sua conexão e tente novamente");
							}
							setLoading(false);
						});
				}
			})
			.catch((err) => {
				let message = err?.response?.data?.message || err?.message;
				if (message && message.includes && message.includes("email")) {
					showError("O email informado é inválido, por favor, verifique e tente novamente");
				} else {
					showError(message || "Verifique sua conexão e tente novamente");
				}
				setLoading(false);
			});
	};

	const footer = () => {
		return (
			<div style={{ padding: "0 15px 15px 15px" }}>
				<Grid container justify="center">
					<Grid item xs={12} container justify="center">
						<Button onClick={typePaymentPackage} className={classes.root}>
							{t("Make payment")}
						</Button>
					</Grid>
				</Grid>
			</div>
		);
	};

	const CheckoutForm = () => {
		const stripe = useStripe();
		const elements = useElements();
		const [isLoading, setIsLoading] = useState(false);

		const [openCheckoutStripe, setOpenCheckoutStripe] = useState(true);

		useEffect(() => {
			if (!stripe) {
				return;
			}
			const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");
			if (!clientSecret) {
				return;
			}

			stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
				switch (paymentIntent.status) {
					case "succeeded":
						dialog.withMessage(t("Payment succeeded")).show();
						break;
					case "processing":
						dialog.withMessage(t("Payment is being processed")).show();
						break;
					case "requires_payment_method":
						dialog.withMessage(t("Payment was not successful")).show();
						break;
					default:
						dialog.withMessage(t("Payment with error")).show();
						break;
				}
			});
		}, [stripe]);

		const handleSubmit = async (e) => {
			e.preventDefault();

			if (!stripe || !elements) {
				return;
			}

			setIsLoading(true);

			const { error } = await stripe.confirmPayment({
				elements,
				confirmParams: {
					return_url: `${process.env.REACT_APP_URL}/confirmation-package/${business?.id}/bookingTransactionId/${bookingTransactionId}`,
				},
			});

			if (error) {
				if (
					error.message !== "O número do seu cartão está incompleto." &&
					error.message !== "A data de expiração do seu cartão está incompleta." &&
					error.message !== "O código de segurança do seu cartão está incompleto."
				) {
					dialog.withMessage(error.message).show();
				}
			} else {
				// if (bookingOkId) {
				// 	postBooking();
				// } else {
					dialog.withMessage("booking não gerado").show();
				// }
			}

			setIsLoading(false);
			// setOpenCheckoutStripe(false);
		};

		return (
			<Dialog
				PaperProps={{
					style: { borderRadius: 20, maxWidth: 312, minHeight: 430 },
				}}
				open={clientSecret && stripe && openCheckoutStripe}
				title={t("Confirm payment")}>
				<DialogTitle>
					<TitleDialog onClose={onClose} message={t("Confirm payment")} />
				</DialogTitle>
				<div style={{ padding: "20px", display: "flex", justifyContent: "center" }}>
					<form id="payment-form" onSubmit={handleSubmit}>
						<PaymentElement id="payment-element" />
						<button
							style={{
								backgroundColor: "#3689ea",
								color: "#ffffff",
								height: 44,
								width: "100%",
								fontSize: 12,
								fontWeight: "normal",
								textTransform: "none",
								borderRadius: 20,
								marginTop: "45px",
								borderColor: "transparent",
								"&:hover": {
									backgroundColor: "#106ba3",
								},
							}}
							disabled={isLoading || !stripe || !elements}
							id="submit">
							{isLoading ? <SpinnerLoading loading={true} /> : t("Make payment")}
						</button>
					</form>
				</div>
			</Dialog>
		);
	};

	const formatCPF = (value) => {
		if (!value) return "";
		const digits = value.replace(/\D/g, "");
		return digits
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d{1,2})/, "$1-$2");
	};

	return (
		<>
			{clientSecret && stripePromise && (
				<Elements options={options} stripe={stripePromise}>
					<CheckoutForm />
				</Elements>
			)}
			<DialogError
				message={errorMessage}
				onOpen={errorOpen}
				onClose={() => setErrorOpen(false)}
				onOk={() => setErrorOpen(false)}></DialogError>
			<SpinnerLoading loading={loading} />

			<div className={classes.pixConfirmContainer}>
				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
					<Typography className={classes.pixConfirmTitle} style={{ marginBottom: 0 }}>
						{pix ? t("Confirm Pix data") : t("Confirm card data")}
					</Typography>
					<button
						style={{
							background: "none",
							border: "none",
							fontSize: 18,
							color: "#999",
							cursor: "pointer",
							padding: 4,
							lineHeight: 1,
						}}
						onClick={onClose}
					>
						&#x2715;
					</button>
				</div>

				<div className={classes.pixConfirmBusinessRow}>
					<Avatar alt={business.name} src={business.thumbnailUrl} />
					<div>
						<Typography className={classes.pixConfirmBusinessName}>{business.name}</Typography>
						<Typography className={classes.pixConfirmBusinessAddress}>{business.address?.street}</Typography>
					</div>
				</div>

				<Divider className={classes.pixConfirmDivider} />

				<Typography className={classes.pixConfirmLabel}>
					{t("Amount to pay now")}
				</Typography>
				<Typography className={classes.pixConfirmValue}>
					{Utils.formatMoney((checkoutInformation?.anticipation_payment / 100), currency)}
				</Typography>

				<Divider className={classes.pixConfirmDivider} />

				{pix ? (
					<>
						<div className={classes.pixConfirmCpfRow}>
							<Typography className={classes.pixConfirmCpfLabel}>CPF</Typography>
							<Typography className={classes.pixConfirmCpfValue}>
								{formatCPF(pix)}
							</Typography>
						</div>

						<Divider className={classes.pixConfirmDivider} />

						{business?.currency === "BRL" && (
							<Typography
								className={classes.pixConfirmChangeLink}
								onClick={() => showUpdateInfo()}
							>
								{t("Change document")}
							</Typography>
						)}
					</>
				) : (
					<>
						<div className={classes.pixConfirmCpfRow}>
							<Typography className={classes.pixConfirmCpfLabel}>{t("Card number")}</Typography>
							<Typography className={classes.pixConfirmCpfValue}>
								{Utils.formatCardNumber(cardData?.number)}
							</Typography>
						</div>
						<div className={classes.pixConfirmCpfRow}>
							<Typography className={classes.pixConfirmCpfLabel}>{t("Validity")}</Typography>
							<Typography className={classes.pixConfirmCpfValue}>
								{cardData?.expiry?.replace(/(\d{2})(\d{2})/, "$1/$2")}
							</Typography>
						</div>

						<Divider className={classes.pixConfirmDivider} />

						{business?.currency === "BRL" && (
							<Typography
								className={classes.pixConfirmChangeLink}
								onClick={() => showUpdateInfo()}
							>
								{t("Change card number")}
							</Typography>
						)}
					</>
				)}

				<ButtonDefault onClick={typePaymentPackage}>
					{pix ? t("Generate Pix") : t("Make payment")}
				</ButtonDefault>

				<Typography className={classes.titlePoli}>{Utils.policyDetails(checkoutInformation, currency, t)}</Typography>
			</div>
		</>
	);
};

export default withRouter(DialogPayConfirmPackage);
